<template>
  <div v-if="isWeb"
       class="toast" v-show="show">
    <p class="toast-msg">{{ msg }}</p>
  </div>
</template>

<script>
import Vue from 'vue';

export default {
  name: 'HyToast',
  data() {
    return {
      isWeb: !Vue.Native,
      show: false,
    };
  },
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    msg: {
      type: String,
      required: true,
    },
    duration: {
      type: Number,
      required: false,
    },
  },
  created() {
  },
  watch: {
    visible() {
      if (this.visible) {
        this.show = this.visible;
        if (!this.isWeb) {
          this.showToast(this.msg);
          this.hideToast();
        } else {
          setTimeout(() => {
 this.hideToast();
}, this.duration ? this.duration : 1000);
        }
      }
    },
  },
  computed: {
  },
  methods: {
    showToast(msg) {
      Vue.Native.callNative('TgclubJsModule', 'showToast', this.$root.$options.rootViewId, msg);
    },
    hideToast() {
      this.show = false;
      this.$emit('hideToast', false);
    },
  },
};
</script>

<style scoped>
  .toast {
    box-sizing: border-box;
    position: fixed;
    padding: 10px;
    z-index: 99;
  left: 50%;
  top: 50%;
    transition: all .3s ease;
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.7);
    color: #fff;
    text-align: center;
  transform: translate(-50%,-50%);
 }
  .toast-msg {
      text-align: center;
  }
</style>
